import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISpecialAccessUser } from "src/models/Maintenance/SpecialAccessUser.models";

interface SpecialAccessUserState {
  specialAccessUsers: ISpecialAccessUser[];
  specialAccessUserToEdit: ISpecialAccessUser | null;
}

const initialState: SpecialAccessUserState = {
  specialAccessUsers: [],
  specialAccessUserToEdit: null,
};

const specialAccessUserSlice = createSlice({
  name: "SpecialAccessUser",
  initialState,
  reducers: {
    setSpecialAccessUserList: (
      state,
      action: PayloadAction<ISpecialAccessUser[]>
    ) => {
      state.specialAccessUsers = action.payload;
    },
    concatListSpecialAccessUser: (
      state,
      action: PayloadAction<ISpecialAccessUser[]>
    ) => {
      state.specialAccessUsers = [
        ...state.specialAccessUsers.concat(action.payload),
      ];
    },
    setSpecialAccessUserToEdit: (
      state,
      action: PayloadAction<ISpecialAccessUser | null>
    ) => {
      state.specialAccessUserToEdit = action.payload;
    },
    addSpecialAccessUser: (state, action: PayloadAction<ISpecialAccessUser>) => {
      state.specialAccessUsers.push(action.payload);
    },
    updateSpecialAccessUser: (
      state,
      action: PayloadAction<ISpecialAccessUser>
    ) => {
      const itemIndex = state.specialAccessUsers.findIndex(
        item =>
          item.specialAccessUserId === action.payload.specialAccessUserId
      );
      if (itemIndex !== -1) {
        state.specialAccessUsers[itemIndex] = action.payload;
      }
    },
    deleteSpecialAccessUser: (state, action: PayloadAction<number>) => {
      state.specialAccessUsers = state.specialAccessUsers.filter(
        item => item.specialAccessUserId !== action.payload
      );
    },
  },
});

export const {
  setSpecialAccessUserList,
  concatListSpecialAccessUser,
  setSpecialAccessUserToEdit,
  addSpecialAccessUser,
  updateSpecialAccessUser,
  deleteSpecialAccessUser,
} = specialAccessUserSlice.actions;

export default specialAccessUserSlice.reducer;
